document.addEventListener("DOMContentLoaded", () => {
  const animatedEls = document.querySelectorAll(".ky-anim");

  if ("IntersectionObserver" in window) {
    const observer = new IntersectionObserver(
      (entries, obs) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add("is-visible");
          obs.unobserve(entry.target);
        });
      },
      {
        threshold: 0.15,
        rootMargin: "0px 0px -8% 0px",
      }
    );

    animatedEls.forEach((el) => observer.observe(el));
  } else {
    animatedEls.forEach((el) => el.classList.add("is-visible"));
  }
});

document.addEventListener("DOMContentLoaded", () => {
  const sliders = document.querySelectorAll("[data-ky-slider]");

  sliders.forEach((slider) => {
    const track = slider.querySelector(".ky-item-card__track");
    const slides = Array.from(slider.querySelectorAll(".ky-item-card__slide"));
    const prevBtn = slider.querySelector(".ky-item-card__nav--prev");
    const nextBtn = slider.querySelector(".ky-item-card__nav--next");
    const dots = Array.from(slider.querySelectorAll(".ky-item-card__dot"));

    if (!track || slides.length === 0) return;

    let current = 0;
    const maxIndex = slides.length - 1;

    const updateDots = () => {
      if (!dots.length) return;
      dots.forEach((dot, i) => {
        dot.classList.toggle("is-active", i === current);
      });
    };

    const updateArrows = () => {
      if (prevBtn) {
        prevBtn.classList.toggle("is-disabled", current === 0);
      }
      if (nextBtn) {
        nextBtn.classList.toggle("is-disabled", current === maxIndex);
      }
    };

    const update = () => {
      track.style.transform = `translateX(-${current * 100}%)`;
      updateDots();
      updateArrows();
    };

    const goTo = (index) => {
      current = Math.max(0, Math.min(index, maxIndex));
      update();
    };

    const next = () => {
      if (current < maxIndex) {
        current += 1;
        update();
      }
    };

    const prev = () => {
      if (current > 0) {
        current -= 1;
        update();
      }
    };

    prevBtn?.addEventListener("click", prev);
    nextBtn?.addEventListener("click", next);

    dots.forEach((dot, i) => {
      dot.addEventListener("click", () => goTo(i));
    });

    update();
  });
});
